document.addEventListener('DOMContentLoaded', () => {
  initRevelado();
  initPasosEscena();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
});

function initGaleriaProducto() {
  const miniaturas = document.querySelectorAll('[data-mt-miniatura]');
  const imagenes = document.querySelectorAll('[data-mt-galeria-img]');
  if (!miniaturas.length || !imagenes.length) return;

  miniaturas.forEach((btn) => {
    btn.addEventListener('click', () => {
      const indice = parseInt(btn.dataset.mtIndice, 10);
      imagenes.forEach((img, i) => img.classList.toggle('mt-producto-galeria-img-activa', i === indice));
      miniaturas.forEach((b) => b.classList.toggle('mt-producto-miniatura-activa', b === btn));
    });
  });
}

function initVariantesProducto() {
  const form = document.querySelector('.mt-producto-form');
  if (!form) return;
  const dataEl = form.querySelector('[data-mt-variantes]');
  if (!dataEl) return;

  const variantes = JSON.parse(dataEl.textContent);
  const grupos = form.querySelectorAll('[data-mt-opcion-indice]');
  const inputId = form.querySelector('[data-mt-variant-id]');
  const btnAdd = form.querySelector('[data-mt-add-btn]');
  const btnAddTexto = form.querySelector('[data-mt-add-texto]');
  const precioEl = document.querySelector('.mt-producto-precio-actual');

  const seleccion = [];
  grupos.forEach((grupo) => {
    const activo = grupo.querySelector('.mt-pill-activo');
    seleccion.push(activo ? activo.dataset.mtValor : null);
  });

  const formatoMoneda = (centavos) => {
    if (!precioEl) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(centavos / 100);
    } catch {
      return (centavos / 100).toFixed(2);
    }
  };

  const actualizar = () => {
    const variante = variantes.find((v) => v.options.every((opt, i) => opt === seleccion[i]));
    if (!variante) return;
    inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
    if (variante.available) {
      btnAdd.removeAttribute('disabled');
      if (btnAddTexto) btnAddTexto.textContent = form.dataset.mtTextoComprar || btnAddTexto.dataset.mtDefault || btnAddTexto.textContent;
    } else {
      btnAdd.setAttribute('disabled', 'disabled');
      if (btnAddTexto) btnAddTexto.textContent = form.dataset.mtTextoAgotado || 'Sold Out';
    }
  };

  grupos.forEach((grupo, i) => {
    grupo.querySelectorAll('.mt-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        grupo.querySelectorAll('.mt-pill').forEach((p) => p.classList.remove('mt-pill-activo'));
        pill.classList.add('mt-pill-activo');
        seleccion[i] = pill.dataset.mtValor;
        actualizar();
      });
    });
  });
}

function initRevelado() {
  const items = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!items.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    items.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.mtDelay || 0;
          setTimeout(() => entry.target.classList.add('mt-visible'), delay);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  items.forEach((el) => observer.observe(el));
}

function initPasosEscena() {
  const escenas = document.querySelectorAll('.mt-pasos-escena');
  if (!escenas.length) return;

  escenas.forEach((escena) => {
    const items = escena.querySelectorAll('.mt-paso-item');
    const imgs = escena.querySelectorAll('.mt-pasos-visual img');
    if (!items.length || !imgs.length) return;

    const activar = (index) => {
      items.forEach((it, i) => it.classList.toggle('mt-paso-item-activo', i === index));
      imgs.forEach((img, i) => img.classList.toggle('mt-paso-activo', i === index));
    };
    activar(0);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Array.from(items).indexOf(entry.target);
            activar(index);
          }
        });
      },
      { threshold: 0.5, rootMargin: '-35% 0px -35% 0px' }
    );
    items.forEach((it) => observer.observe(it));
  });
}

function initContadores() {
  const nums = document.querySelectorAll('[data-mt-count]');
  if (!nums.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const anima = (el) => {
    const target = parseFloat(el.dataset.mtCount);
    const suffix = el.dataset.mtSuffix || '';
    const decimals = el.dataset.mtCount.includes('.') ? 1 : 0;
    if (reduce) {
      el.textContent = target.toLocaleString('es-ES', { maximumFractionDigits: decimals }) + suffix;
      return;
    }
    const dur = 1400;
    const start = performance.now();
    const paso = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const val = target * eased;
      el.textContent = val.toLocaleString('es-ES', { maximumFractionDigits: decimals }) + suffix;
      if (p < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          anima(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.6 }
  );
  nums.forEach((el) => observer.observe(el));
}
